import { RefObject } from 'react';
import { RoleChip } from '../../RoleChip/RoleChip';
import { StatusChip } from '../../StatusChip/StatusChip';
import { UserMenu } from '../../UserMenu/UserMenu';
import styles from './UsersItem.module.scss';
import cx from 'classnames';
import { Text } from 'components';
import { User } from 'types';

type Props = {
  user: User;
  tableRef: RefObject<HTMLDivElement>;
};

export const UsersItem = ({ user, tableRef }: Props) => {
  return (
    <div className={styles.container}>
      <div className={cx(styles.cell, styles.name)}>
        <Text type="overline" className={styles.cellName}>
          Name
        </Text>
        <Text type="body2" className={cx(styles.cellTextValue)}>
          {user.name}
        </Text>
      </div>
      <div className={cx(styles.cell, styles.email)}>
        <Text type="overline" className={styles.cellName}>
          Login Email
        </Text>
        <Text type="body2" className={cx(styles.cellTextValue)}>
          {user.email}
        </Text>
      </div>
      <div className={cx(styles.cell, styles.role)}>
        <Text type="overline" className={styles.cellName}>
          User Role
        </Text>
        <RoleChip role={user.role} />
      </div>
      <div className={cx(styles.cell, styles.status)}>
        <Text type="overline" className={styles.cellName}>
          Status
        </Text>
        <StatusChip status={user.status} className={(styles.statusText, styles.cellTextValue)} />
        <div className={styles.editButton}>
          <UserMenu user={user} tableRef={tableRef} />
        </div>
      </div>
    </div>
  );
};
